<template>
  <div :class="classes">
    <pt-form-item label="中文名称" :required="true" :labelWidth="labelWidth">
      <el-input :disabled="disabled" v-model="form.chineseName" name="chineseName" v-validate="'required'" data-vv-as="中文名称" placeholder="请输入中文名称"></el-input>
    </pt-form-item>
    <pt-form-item label="英文名称" :labelWidth="labelWidth">
      <el-input :disabled="disabled"  v-model="form.englishName" placeholder="请输入英文名称"></el-input>
    </pt-form-item>
    <pt-form-item label="适用性别" :labelWidth="labelWidth">
      <detection-config-gender-selector :disabled="disabled"  v-model="form.gender"></detection-config-gender-selector>
    </pt-form-item>
    <pt-form-item label="检测项类型" :labelWidth="labelWidth">
      <detection-category-selector :disabled="disabled"  v-model="form.category"></detection-category-selector>
    </pt-form-item>
    <pt-form-item label="标签" :labelWidth="labelWidth">
      <!-- 标签组件 -->
			<detection-tag :disabled="disabled"  v-model="form.tags"></detection-tag>
    </pt-form-item>
  </div>
</template>

<script>
import detectionTag from 'cps/gene-product/selector/detection-tag'
import detectionCategorySelector from 'cps/gene-product/selector/detection-category-selector'
import detectionConfigGenderSelector from 'cps/gene-product/selector/detection-config-gender-selector'
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-detection-form'

export default {
  name: 'pt-detection-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    detectionTag,
    detectionCategorySelector,
    detectionConfigGenderSelector
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      labelWidth: '110px',
      form: JSON.stringify(this.value) !== '{}' ? this.value : {
        chineseName: '',
        englishName: '',
        category: '',
        gender: '',
        tags: [],
        engineDefault: false
      }
    }
  },
  watch: {
    form: {
      handler: function (val) {
        console.log('val---', val)
        this.$emit('input', val)
      },
      deep: true
    },
    value: {
      handler: function (val) {
        this.form = val
      },
      deep: true
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-detection-form{
  margin-bottom: 20px;
  .el-select,.el-input{
    max-width: 280px;
  }
  .wt-selector{
    width: 100%;
  }
}
</style>
